

























































































































export default {
  name: "AnexoIReportPage",
  props: {
    page: {
      type: Object,
      required: true
    },
    num_page: {
      type: Number,
      required: true
    },
    total_pages: {
      type: Number,
      required: true
    }
  },
  computed: {
    reportData() {
      var res = this.page.reportData;
      console.log('this.page.reportData.grantor =>:: ', this.page.reportData.grantor)
      return res
    },
    currentDate() {
      const today = new Date();
      const months = [
        'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
        'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
      ];
      return {
        day: today.getDate(),
        month: months[today.getMonth()],
        year: today.getFullYear()
      };
    },
    grantorSignDate() {
      const sign = this.reportData.grantorSign || {};
      return {
        day: sign.day || this.currentDate.day,
        month: sign.month || this.currentDate.month,
        year: sign.year || this.currentDate.year
      };
    },
    providerSignDate() {
      const sign = this.reportData.providerSign || {};
      return {
        day: sign.day || this.currentDate.day,
        month: sign.month || this.currentDate.month,
        year: sign.year || this.currentDate.year
      };
    }
  }
}
